import { createAction, props } from '@ngrx/store';
import { LookBook, Media } from '@epicuro-next/models/engagement';

export const loadLookBooks = createAction('[ShopTheLook] Load lookBooks');
export const loadLookBooksSuccess = createAction(
  '[ShopTheLook] Load lookBooks success',
  props<{ lookBooks: LookBook[]; total: number }>(),
);
export const loadLookBooksError = createAction(
  '[ShopTheLook] Load lookBooks error',
  props<{ error: string }>(),
);

export const updateLookBookItemMedia = createAction(
  '[ShopTheLook] Update Item in LookBook items',
  props<{ listId: string; media: Partial<Media> }>(),
);

export const resetLookBooks = createAction('[ShopThelook] Reset lookbooks');
